import type { ReactNode } from 'react';

export const symbol_power_input: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-390q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-450 110-450h154q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Zm273 0q-13 0-21-8.68-8-8.67-8-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h153q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H383Zm273 0q-13 0-21-8.68-8-8.67-8-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h153q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H656ZM110-510q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-570 110-570h700q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Z"
		/>
	</svg>
);
